import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en/translation.json";
import frTranslations from "./locales/fr/translation.json";
import { getLocale } from "../utils/localstorage";

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: enTranslations,
            },
            fr: {
                translation: frTranslations,
            },
        },
        lng: getLocale() || "en",
        fallbackLng: "en",

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
